import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const NameSlice =  createSlice({
    name:"Suscripcion",
    initialState:{
        name:""
    },
    reducers:{
        SetNamesus(state, action: PayloadAction<string>){
            state.name = action.payload
        }
    }
});

export const { SetNamesus } = NameSlice.actions
export default NameSlice.reducer